export interface FaqItem {
  id: string;
  question: string;
  answer: string;
}

export const siteFaqs: FaqItem[] = [
  {
    id: 'faq-1',
    question: '韩漫屋是什么网站？',
    answer: '韩漫屋是官方认证的韩漫官网站，提供海量好看的韩国漫画免费在线观看。我们收录了涵盖恋爱、奇幻、动作、悬疑、搞笑、古风、都市等多种类型的热门韩漫，每日更新最新章节，为漫画爱好者打造优质的在线漫画阅读平台。',
  },
  {
    id: 'faq-2',
    question: '韩漫屋的漫画是否需要付费？',
    answer: '韩漫屋始终坚持免费在线观看的运营模式，所有韩国漫画资源均可免费阅读。用户无需支付任何费用，即可畅享海量优质韩漫内容。我们通过广告等合理方式维持网站运营，确保为用户提供持续稳定的免费阅读服务。',
  },
  {
    id: 'faq-3',
    question: '韩漫屋的漫画更新频率如何？',
    answer: '韩漫屋与韩国各大漫画平台保持紧密合作，热门连载漫画通常每周更新一话，部分人气作品可能实现更频繁的更新。我们会在第一时间同步最新章节，确保读者能够及时阅读到最新内容。',
  },
  {
    id: 'faq-4',
    question: '韩漫屋支持哪些设备阅读？',
    answer: '韩漫屋采用响应式网页设计，完美适配电脑、平板和手机等各种设备。无论在哪种设备上访问，都能获得流畅、舒适的漫画阅读体验。推荐使用Chrome、Safari等主流浏览器访问以获得最佳效果。',
  },
  {
    id: 'faq-5',
    question: '如何在韩漫屋找到想看的漫画？',
    answer: '您可以通过多种方式在韩漫屋查找漫画：1）使用网站顶部的搜索功能直接搜索漫画名称；2）在首页浏览热门推荐和最新更新；3）通过分类页面按恋爱、奇幻、动作等类型筛选漫画；4）查看排行榜了解最受欢迎的韩漫作品。',
  },
  {
    id: 'faq-6',
    question: '韩漫屋的漫画画质如何？',
    answer: '韩漫屋提供的所有韩国漫画均为高清画质，经过专业优化处理，确保画面清晰细腻，色彩还原准确。我们采用先进的图片压缩和加载技术，在保证画质的同时实现快速加载，为您带来最佳的视觉享受。',
  },
  {
    id: 'faq-7',
    question: '是否可以在韩漫屋下载漫画？',
    answer: '为保护漫画作者的版权，韩漫屋目前仅提供在线浏览服务，不支持漫画下载功能。我们尊重每一位创作者的劳动成果，也呼吁广大读者支持正版，共同维护健康的漫画创作生态。',
  },
];